/**
 * Ürün açıklaması: uzun metni kes, "Devamını oku" ile aç.
 *
 * Düğme yalnızca metin kesilecek kadar uzunsa görünür. Eşik CSS'te (--component-product-
 * description-max) tanımlı; buradaki ölçüm gerçek yüksekliğe bakar, sabit karakter sayısı
 * varsaymaz.
 */
if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-product-description-body]');
        this.toggle = this.querySelector('[data-product-description-toggle]');
        this.moreLabel = this.querySelector('[data-product-description-more]');
        this.lessLabel = this.querySelector('[data-product-description-less]');
        if (!this.body || !this.toggle) return;

        this.dataset.state = 'collapsed';
        this.toggle.addEventListener('click', () => this.durumDegistir());

        // Görseller yüklendikçe yükseklik değişir; ilk ölçüm yanlış çıkmasın.
        this.olcumYap();
        if ('ResizeObserver' in window) {
          this.gozlemci = new ResizeObserver(() => this.olcumYap());
          this.gozlemci.observe(this.body);
        }
      }

      disconnectedCallback() {
        this.gozlemci?.disconnect();
      }

      /** Metin kutuya sığıyorsa düğmeye gerek yok. */
      olcumYap() {
        if (this.dataset.state === 'expanded') return;
        const tasiyor = this.body.scrollHeight - this.body.clientHeight > 4;
        this.toggle.hidden = !tasiyor;
        this.dataset.overflow = tasiyor ? 'true' : 'false';
      }

      durumDegistir() {
        const acik = this.dataset.state === 'expanded';
        this.dataset.state = acik ? 'collapsed' : 'expanded';
        this.toggle.setAttribute('aria-expanded', String(!acik));
        this.moreLabel.hidden = !acik;
        this.lessLabel.hidden = acik;
        if (acik) this.scrollIntoView({ block: 'nearest' });
      }
    }
  );
}
